/** 退款操作类型 */
export enum ActionType {
    /** 仅退款 */
    REFUND = '仅退款',
    /** 同意买家退货 */
    AGREE_RETURN = '同意买家退货',
    /** 退货退款 */
    RETURN_REFUND = '退货退款'
}

/** 支持异步处理退款的操作类型 */
export const SUPPORTED_ACTION_TYPES = [ActionType.REFUND, ActionType.RETURN_REFUND, ActionType.AGREE_RETURN] as const
